/**
 * EX-619: los dos identificadores de integración de una sucursal.
 *
 * `merchantId` es el `merchant_location_id` numérico del pago online de Paynopain y
 * `posmsMerchantUuid` el UUID del comercio de los datáfonos. Son de productos distintos y no
 * tienen nada que ver entre sí; solo comparten que los administra la plataforma, no el comercio.
 */
export const ROLES_PLATAFORMA = ['SUPERADMIN_ROLE', 'ADMIN_ROLE'];

export const esRolPlataforma = (role) => ROLES_PLATAFORMA.includes(role);

/**
 * Qué campos de integración viajan en el guardado de la sucursal.
 *
 * Desde un rol de negocio se omiten **los dos**, y no se mandan vacíos: el backend traduce el
 * cuerpo a un `$set` de las claves presentes, así que una clave ausente deja intacto lo guardado
 * y una presente y vacía lo pisaría. El backend descarta por su cuenta `posmsMerchantUuid`
 * (EX-618), pero `merchantId` no está acotado por rol allí, así que la pantalla que no los pinta
 * tampoco puede mandarlos: si no, esconder el input bastaría para borrar el merchant del pago
 * online al guardar cualquier otra cosa.
 *
 * El comercio se pasa aparte porque no vive en el objeto de la sucursal: no llega en la lectura
 * que puebla el formulario —ese endpoint es público— sino en la suya propia.
 */
export const camposIntegracionParaGuardar = (
    sucursal = {},
    { role, comercio = '', comercioResuelto = false } = {}
) => {
    const { merchantId, posmsMerchantUuid, ...sucursalSinIntegracion } = sucursal;

    if (!esRolPlataforma(role)) return sucursalSinIntegracion;

    const camposDePlataforma = {
        ...sucursalSinIntegracion,
        merchantId: merchantId || '',
    };

    // Si la lectura del comercio no se ha resuelto, la clave no viaja: el formulario tiene la
    // cadena vacía porque no ha llegado a saber qué hay guardado, no porque el usuario lo haya
    // vaciado, y mandarla borraría el comercio al guardar cualquier otro campo de la ficha.
    // Misma disciplina que `datafonosParaGuardar` con la asociación (EX-614).
    if (!comercioResuelto) return camposDePlataforma;

    return {
        ...camposDePlataforma,
        posmsMerchantUuid: String(comercio || '').trim(),
    };
};
